import { BaseOrdersClient } from "../types/clients";
import { ParhatoOrder, SupaOrderDataType } from "./types";
import {
  convertCreateOrderToParhato,
  convertOrderReviewSB,
  convertSBOrderReview,
  convertSupaOrderDataToBaseOrder,
} from "./converters";
import {
  CreateOrderData,
  CreatePaymentPayload,
  OrderHistory,
  OrderReviewType,
  ORDERS_HISTORY_PARAMS,
  ORDERS_PARAMS,
  OrderTracking,
  OrderTrackingPayload,
  PaymentFormData,
  TOrder,
} from "@core/types";
import { supabaseClient } from "../../../../4time/src/shared/supabase";
import { OrderReviewSB } from "../../../../4time/src/shared/clients/types";
import WooComAPI from "../../../../providers/WooComAPI/woo-com-api";

class OrdersClient extends BaseOrdersClient {
  async getOrders(params: ORDERS_PARAMS): Promise<TOrder[]> {
    const response = await this.instance.get<SupaOrderDataType[]>("wp-json/wc/v3/orders/mine", {
      params: { ...params },
    });

    return response.data.map(convertSupaOrderDataToBaseOrder);
  }

  async getUnpaidOrdersId(): Promise<TOrder["id"][]> {
    const response = await this.instance.get<ParhatoOrder["id"][]>("wp-json/wc/v3/orders/unpaid");

    return response.data;
  }

  async getUnreviewedOrdersId(): Promise<TOrder["id"][]> {
    throw new Error("getUnreviewedOrdersId is not implemented");
  }

  async getOrderById(id: string): Promise<TOrder> {
    const response = await this.instance.get<SupaOrderDataType>(`/wp-json/wc/v3/orders/mine/${id}`);

    return convertSupaOrderDataToBaseOrder(response.data);
  }

  async createOrder(orderData: CreateOrderData) {
    const parhatoOrder = convertCreateOrderToParhato(orderData);

    await this.instance.post<unknown>("wp-json/parhato-api/v1/orders", parhatoOrder);

    // return convertParhatoOrderToBaseOrder(response.data);
    return { ...orderData };
  }

  async createPayment(payload: CreatePaymentPayload): Promise<PaymentFormData> {
    throw new Error("createPayment not implemented");
  }

  async getReviewSetOrderById(id: string): Promise<OrderReviewType | null> {
    const { data: orderReview } = await supabaseClient.functions.invoke<OrderReviewSB>("get-order-review", {
      body: {
        orderId: id,
      }
    });

    return orderReview && convertSBOrderReview(orderReview);
  }

  async addReviewOrder(orderData: OrderReviewType): Promise<OrderReviewType | null> {
    const orderReview = convertOrderReviewSB(orderData);

    const { data } = await supabaseClient.functions.invoke<OrderReviewSB>("add-order-review", {
      body: {
        orderReview,
      }
    });

    return convertSBOrderReview(data!);
  }

  async getOrdersHistory(params: ORDERS_HISTORY_PARAMS): Promise<OrderHistory[]> {
    throw new Error("getOrdersHistory not implemented");
  }
  async getOrderTracking(orderReqData: OrderTrackingPayload): Promise<OrderTracking | null> {
    throw new Error("getOrderTracking is not implemented");
  }

  async orderCancel(orderId: string): Promise<Partial<TOrder>> {
    throw new Error("orderCancel is not implemented");
  }

  async createTaxiOrder(orderId: TOrder["id"]): Promise<any> {
    throw new Error("createTaxiOrder is not implemented");
  }
}

export default OrdersClient;
